<template>
    <v-container :pa-0="$vuetify.breakpoint.mdAndDown" :mt-5="$vuetify.breakpoint.xsOnly">
        <v-layout justify-center>
            <v-flex xs12 xl8>
                <v-container grid>
                    <div v-if="loading" class="loading">
                        <v-layout fill-height justify-center align-center row wrap>
                            <v-flex xs12 class="text-xs-center">
                                <v-progress-circular
                                        :size="70"
                                        :width="7"
                                        color="#006a64"
                                        indeterminate
                                        v-if="loading"
                                ></v-progress-circular>
                            </v-flex>
                        </v-layout>
                    </div>
                    <div v-if="showCamBlockedInfo" class="cam-blocked-info">
                        <div class="cam-blocked-tip chrome" v-if="browserIsChrome">
                            <object data="/images/arrow_01.svg" type="image/svg+xml" width="50" height="70">
                                <img src="/images/arrow_01.png" alt="arrow" width="50" height="70">
                            </object>
                            <span>Klikkaa tänne ylös <br />
                                salliaksesi web-kamera.</span>
                        </div>
                        <div class="cam-blocked-tip firefox" v-if="browserIsFirefox">
                            <object data="/images/arrow_02.svg" type="image/svg+xml" width="50" height="70">
                                <img src="/images/arrow_02.png" alt="arrow" width="50" height="70">
                            </object>
                            <span>Klikkaa tänne ylös <br />
                                salliaksesi web-kamera.</span>
                        </div>
                        <v-layout justify-center :mb-2="$vuetify.breakpoint.mdAndDown" :mb-5="$vuetify.breakpoint.lgAndUp" :mt-5="$vuetify.breakpoint.smAndDown && !$vuetify.breakpoint.xsOnly" :mt-0="$vuetify.breakpoint.xsOnly">
                            <v-flex xs12 md8 lg7 xl8>
                                <v-alert
                                        :value="true"
                                        color="#dcffff"
                                        icon="videocam_off"
                                        outline
                                        @click="reloadApp"
                                        style="cursor: default;"
                                >
                                    <template v-if="!browserIsEdge">Jotta voit opettaa konettasi sinun tulee sallia web-kameran käyttö ja ladata sivu uudelleen painamalla tästä. Videota tai kuvia ei lähetä palvelimelle, vaan kaikki tapahtuu paikallisesti omalla laitteellasi.</template>
                                    <template v-if="browserIsEdge">Jotta voit opettaa konettasi sinun tulee ladata sivu uudelleen painamalla tästä ja sallia web-kameran käyttö selaimen alareunasta. Videota tai kuvia ei lähetä palvelimelle, vaan kaikki tapahtuu paikallisesti omalla laitteellasi.</template>
                                </v-alert>
                            </v-flex>
                        </v-layout>
                    </div>
                    <v-layout v-show="!loading" row wrap align-center justify-center justify-space-between>
                        <v-flex xs12 lg3 class="text-xs-center" :pb-5="$vuetify.breakpoint.lgAndUp" :mb-3="$vuetify.breakpoint.mdAndDown">
                            <div class="input">
                                <div class="hb-heading" :class="{'pl-3': $vuetify.breakpoint.lgAndUp}">Syöte</div>
                                <div class="camera">
                                    <div id="video-wrapper"></div>
                                </div>
                                <div class="camera-help caption">
                                    Ei huolta! Kuvia ei lähetetä mihinkään.
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs12 lg5 class="text-xs-center" style="position: relative;" :mb-3="$vuetify.breakpoint.mdAndDown">
                            <canvas class="line-canvas line-input-canvas" id="line-input-canvas" width="57" height="550"></canvas>
                            <canvas class="line-canvas line-output-canvas" id="line-output-canvas" width="46" height="550"></canvas>
                            <div class="hb-heading">Oppiminen</div>
                            <v-layout class="learning pl-2 pt-2 pr-2 pb-1 text-xs-left" row :wrap="$vuetify.breakpoint.lgAndUp">
                                <template v-for="(item, index) in predictItems">
                                    <v-flex :key="index" :ma-0="$vuetify.breakpoint.lgAndUp || $vuetify.breakpoint.xsOnly" :ma-2="$vuetify.breakpoint.mdAndDown && !$vuetify.breakpoint.xsOnly" mb-0 pa-0 xs4 sm4 md4 lg12>
                                        <v-card class="mb-2" light color="#dcffff" :class="{predictedItem: predictClass.classIndex === item}">
                                            <v-card-text class="pa-2">
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm3>
                                                        <span class="caption" :class="getColor(index) + '--text ' + (training === index ? 'font-weight-bold' : '')">{{ exampleCount[item] > 0 ? exampleCount[item] : 0 }} {{ $vuetify.breakpoint.lgAndUp ? 'OTOSTA' : ''}}</span>
                                                        <v-container class="example-images-grid" fluid grid-list-xs pa-0 ma-0 @click="resetClass(index)" :class="{hasImages: exampleImages[index] && exampleImages[index].length > 0}">
                                                            <div style="width: 100%; padding-top: 100%; position: relative;">
                                                                <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;">
                                                                    <v-layout row wrap>
                                                                        <v-flex xs4 :key="i" v-for="(image, i) in exampleImages[index]">
                                                                            <v-img :src="image" style="max-width: 100%; height: auto;"/>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </div>
                                                            </div>
                                                        </v-container>
                                                    </v-flex>
                                                    <v-flex xs12 sm9 :pl-3="$vuetify.breakpoint.smAndUp" :mt-2="$vuetify.breakpoint.xsOnly">
                                                        <span class="caption" :class="getColor(index) + '--text'">VARMUUS</span>
                                                        <v-progress-linear
                                                                class="mt-0"
                                                                :class="{'mb-2': $vuetify.breakpoint.mdAndDown}"
                                                                :value="predictClass.confidences && predictClass.confidences[item] ? predictClass.confidences[item] * 100 : 0"
                                                                :height="$vuetify.breakpoint.lgAndUp ? 24 : 14"
                                                                :color="predictClass.classIndex !== -1 && predictClass.classIndex === item ? getColor(index) : '#a5dede'"></v-progress-linear>
                                                        <v-btn :disabled="loading" :color="getColor(index)"
                                                               @mousedown="() => training = index"
                                                               @mouseup="() => training = false"
                                                               @mouseout="() => training = false"
                                                               @touchstart="(e) => { e.preventDefault(); training = index; }"
                                                               @touchend="(e) => { e.preventDefault(); training = false; }"
                                                               style="width: 100%;"
                                                               :large="$vuetify.breakpoint.lgAndUp"
                                                               class="ma-0 font-weight-bold"
                                                               dark>HARJOITA
                                                                <v-progress-linear v-if="training === index && $vuetify.breakpoint.lgAndUp" height="4" :color="getColor(index)" style="position: absolute; bottom: -11px; left: -31px; right: -32px; margin: 0; width: 127%;" :indeterminate="true"></v-progress-linear>
                                                        </v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </template>
                            </v-layout>
                            <!--
                            <div class="text-xs-center">
                                <v-btn :disabled="loading" @click="addTrainableObject" outline white>Lisää uusi</v-btn>
                                <v-btn :disabled="loading" @click="resetClassifier" outline white>Reset</v-btn>
                            </div>-->
                        </v-flex>
                        <v-flex xs112 lg3 class="results-holder pb-5 text-xs-center">
                            <div class="output">
                                <div class="hb-heading" :class="{'pr-5': $vuetify.breakpoint.lgAndUp}">Tuloste</div>
                                <div class="television">
                                    <div class="result-gifs-holder">
                                        <v-img v-show="predictItems.findIndex(pi => pi === predictClass.classIndex) === 0" src="https://media.giphy.com/media/4Zo41lhzKt6iZ8xff9/giphy.gif" :aspect-ratio="1" ></v-img>
                                        <v-img v-show="predictItems.findIndex(pi => pi === predictClass.classIndex) === 1" src="https://media.giphy.com/media/cMso9wDwqSy3e/giphy.gif" :aspect-ratio="1" ></v-img>
                                        <v-img v-show="predictItems.findIndex(pi => pi === predictClass.classIndex) === 2" src="https://media.giphy.com/media/NAjPVFHtXyc6s/giphy.gif" :aspect-ratio="1" ></v-img>
                                    </div>
                                </div>
                                <div class="gif-thumbs" v-if="!loading">
                                    <v-layout row justify-center>
                                        <v-flex xs3 lg4 class="text-xs-center">
                                            <div class="gif-thumb" :style="{borderColor: getColorHex(0)}" :class="{active: predictItems.findIndex(pi => pi === predictClass.classIndex) === 0}">
                                                <v-img src="https://media.giphy.com/media/4Zo41lhzKt6iZ8xff9/giphy.gif" :aspect-ratio="1" height="46" width="46"></v-img>
                                            </div>
                                        </v-flex>
                                        <v-flex xs3 lg4 class="text-xs-center">
                                            <div class="gif-thumb" :style="{borderColor: getColorHex(1)}" :class="{active: predictItems.findIndex(pi => pi === predictClass.classIndex) === 1}">
                                                <v-img src="https://media.giphy.com/media/cMso9wDwqSy3e/giphy.gif" :aspect-ratio="1" height="46" width="46"></v-img>
                                            </div>
                                        </v-flex>
                                        <v-flex xs3 lg4 class="text-xs-center">
                                            <div class="gif-thumb" :style="{borderColor: getColorHex(2)}" :class="{active: predictItems.findIndex(pi => pi === predictClass.classIndex) === 2}">
                                                <v-img src="https://media.giphy.com/media/NAjPVFHtXyc6s/giphy.gif" :aspect-ratio="1" height="46" width="46"></v-img>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout class="contact-buttons text-xs-center mt-5" v-show="!loading" justify-center :mb-2="$vuetify.breakpoint.mdAndDown" :mb-5="$vuetify.breakpoint.lgAndUp" :mt-5="$vuetify.breakpoint.smAndDown && !$vuetify.breakpoint.xsOnly" :mt-0="$vuetify.breakpoint.xsOnly">
                        <v-flex xs12 md8 lg7 xl8>
                            <v-tooltip bottom color="#d7ffff" style="color: #072c35">
                                <v-btn slot="activator" color="#d7ffff" round outline href="https://hubble.fi/#yhteys" target="_blank">Ota yhteyttä</v-btn>
                                <span>Ota yhteyttä niin kerromme lisää tekoälystä</span>
                            </v-tooltip>
                            <v-tooltip bottom color="#d7ffff" style="color: #072c35">
                                <v-btn slot="activator" color="#d7ffff" round outline  href="http://eepurl.com/ddB17f" target="_blank">Tilaa uutiskirje</v-btn>
                                <span>Tilaa Hubblen uutiskirje, lupaamme olla spämmäämättä</span>
                            </v-tooltip>
                        </v-flex>
                    </v-layout>
                    <canvas ref="canvas" id="canvas" width="50" height="50" style="object-fit: cover; display: none;"></canvas>
                </v-container>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  /* eslint-disable no-console */
  /* eslint-disable */
  import "@babel/polyfill";
  import * as mobilenetModule from '@tensorflow-models/mobilenet';
  import * as tf from '@tensorflow/tfjs';
  import * as knnClassifier from '@tensorflow-models/knn-classifier';

  // Webcam Image size. Must be 227.
  const IMAGE_SIZE = 227;
  // K value for KNN
  const TOPK = 10;

  let EXAMPLE_COUNTER = 0;

  const COLOR_ARRAY = [
    "blue",
    "pink",
    "green",
    "red",
    "purple",
    "lime",
  ]

  const COLOR_ARRAY_HEX = [
    "#2196F3",
    "#E91E63",
    "#4CAF50",
    "#F44336",
    "#9C27B0",
    "#CDDC39",
  ]

  export default {
    name: 'Teachable',
    props: {},
    data() {
      return {
        predictItems: [-1, -1, -1],
        training: false,
        videoPlaying: false,
        loading: true,
        video: false,
        predictClass: -1,
        exampleCount: -1,
        canvas: {},
        exampleImages: {},
        camBlocked: true,
        showCamBlockedInfo: false,
      }
    },
    methods: {
      construct() {

        this.loading = true;
        this.$emit('updateLoadingStatus', this.loading);

        // Initiate deeplearn.js math and knn classifier objects
        this.bindPage();

        // Create video element that will contain the webcam image
        this.video = document.createElement('video');
        this.video.setAttribute('autoplay', '');
        this.video.setAttribute('playsinline', '');
        this.video.style.maxWidth = '100%';
        this.video.style.maxHeight = '100%';

        // Add video element to DOM
        document.getElementById('video-wrapper').appendChild(this.video);

        // Setup webcam
        navigator.mediaDevices.getUserMedia({video: {width: IMAGE_SIZE, height: IMAGE_SIZE}, audio: false})
          .then((stream) => {
            this.showCamBlockedInfo = false;
            this.camBlocked = false;
            this.video.srcObject = stream;
            this.video.width = IMAGE_SIZE;
            this.video.height = IMAGE_SIZE;

            this.video.addEventListener('playing', () => this.videoPlaying = true);
            this.video.addEventListener('paused', () => this.videoPlaying = false);

            if (!this.videoPlaying) {
              this.start();
            }
          })
          .catch(err => {
              this.camBlocked = true;
              this.showCamBlockedInfo = true;
          });
      },
      async bindPage() {
        this.knn = knnClassifier.create();
        this.mobilenet = await mobilenetModule.load().then((res) => {
          this.loading = false;
          this.$emit('updateLoadingStatus', this.loading);
          return res;
        });
        if (!this.camBlocked) this.start();
      },
      start() {
        if (this.timer) {
          this.stop();
        }
        this.video.play();
        this.timer = requestAnimationFrame(this.animate.bind(this));
      },
      stop() {
        this.video.pause();
        cancelAnimationFrame(this.timer);
      },
      async animate() {
        if (this.videoPlaying && !this.loading) {
          // Get image data from video element
          let image = false;
          try {
            image = tf.fromPixels(this.video);
          } catch {
            this.timer = requestAnimationFrame(this.animate.bind(this));
            return;
          }

          let logits;
          // 'conv_preds' is the logits activation of MobileNet.
          const infer = () => this.mobilenet.infer(image, 'conv_preds');

          let numClasses = this.knn.getNumClasses();
          // Train class if one of the buttons is held down
          if (this.training !== false) {
            logits = infer();
            // Add current image to classifier
            if (this.predictItems[this.training] === -1) {
              this.predictItems.splice(this.training, 1, numClasses);
            }
            this.knn.addExample(logits, this.predictItems[this.training]);
            this.canvas = this.$refs.canvas;
            let context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, 50, 50);
            if (this.exampleImages[this.training] === undefined) this.exampleImages[this.training] = [];
            this.exampleImages[this.training].unshift(canvas.toDataURL("image/png"));
            this.exampleImages[this.training] = this.exampleImages[this.training].slice(0, 9);
          }

          numClasses = this.knn.getNumClasses();
          if (numClasses > 0) {
            EXAMPLE_COUNTER++;
            if (this.training === false || EXAMPLE_COUNTER > 20) {
              // If classes have been added run predict
              logits = infer();
              const res = await this.knn.predictClass(logits, TOPK);
              this.predictClass = res;
              EXAMPLE_COUNTER = 0;
            }
            const exampleCount = this.knn.getClassExampleCount();
            this.exampleCount = Object.assign({}, exampleCount);
          }


          // Dispose image when done
          image.dispose();
          if (logits != null) {
            logits.dispose();
          }
        }
        this.timer = requestAnimationFrame(this.animate.bind(this));
      },
      resetClass(index) {
        if (this.exampleImages[index]) {
          this.knn.clearClass(this.predictItems[index]);
          delete this.exampleImages[index];
          delete this.predictClass.confidences[index];
          this.$forceUpdate();
        }
      },
      getColor(index) {
        return COLOR_ARRAY[index];
      },
      getColorHex(index) {
        return COLOR_ARRAY_HEX[index];
      },
      addTrainableObject() {
        this.predictItems.push(-1);
      },
      resetClassifier() {
        this.knn.clearAllClasses();
        this.knn.dispose();
        this.knn = knnClassifier.create();
        this.predictItems = [-1, -1];
        this.exampleImages = {};
        this.predictClass.confidences = {};
        this.deletedList = [];
        this.$forceUpdate();
      },
      drawInputLines(selectedLine) {
        let lineCanvas = document.getElementById('line-input-canvas');
        if(lineCanvas && lineCanvas.getContext){
          let context = lineCanvas.getContext('2d');
          context.clearRect(0, 0, 57, 550);

          let a0x = 0;
          let a0y = -40;
          context.beginPath();
          context.strokeStyle = selectedLine === 0 ? COLOR_ARRAY_HEX[0] : "#0f4856";
          context.lineWidth = 4;
          context.moveTo(a0x+66,a0y+113);
          context.bezierCurveTo(a0x+14,a0y+132,a0x+43,a0y+272,a0x+-9,a0y+293);
          context.stroke();

          let a2x=0;
          let a2y=-40;
          context.beginPath();
          context.strokeStyle = selectedLine === 1 ? COLOR_ARRAY_HEX[1] : "#0f4856";
          context.lineWidth = 4;
          context.moveTo(a2x+70,a2y+297);
          context.bezierCurveTo(a2x+18,a2y+300,a2x+43,a2y+272,a2x+-9,a2y+293);
          context.stroke();

          let a3x=0;
          let a3y=-40;
          context.beginPath();
          context.strokeStyle = selectedLine === 2 ? COLOR_ARRAY_HEX[2] : "#0f4856";
          context.lineWidth = 4;
          context.moveTo(a3x+65,a3y+487);
          context.bezierCurveTo(a3x+13,a3y+455,a3x+43,a3y+272,a3x+-9,a3y+295);
          context.stroke();
        }
      },
      drawOutputLines() {
        let lineCanvas = document.getElementById('line-output-canvas');
        if(lineCanvas && lineCanvas.getContext){
          let context = lineCanvas.getContext('2d');
          context.clearRect(0, 0, 46, 550);

          let a1x=0;
          let a1y=0;
          context.beginPath();
          context.strokeStyle="#0f4856";
          context.lineWidth=4;
          context.moveTo(a1x+53,a1y+201);
          context.bezierCurveTo(a1x+28,a1y+190,a1x+29,a1y+103,a1x+-10,a1y+103);
          context.stroke();

          let a2x=0;
          let a2y=0;
          context.beginPath();
          context.strokeStyle="#0f4856";
          context.lineWidth=4;
          context.moveTo(a2x+69,a2y+241);
          context.bezierCurveTo(a2x+25,a2y+220,a2x+20,a2y+253,a2x+-8,a2y+239);
          context.stroke();

          let a3x=0;
          let a3y=0;
          context.beginPath();
          context.strokeStyle="#0f4856";
          context.lineWidth=4;
          context.moveTo(a3x+56,a3y+286);
          context.bezierCurveTo(a3x+22,a3y+277,a3x+29,a3y+386,a3x+-6,a3y+423);
          context.stroke();
        }
      },
      reloadApp() {
        window.location.reload();
      },
    },
    computed: {
      browserIsFirefox() {
        return navigator.userAgent.indexOf("Firefox") !== -1 && navigator.userAgent.indexOf("Edge") === -1;
      },
      browserIsSafari() {
        return navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Edge") === -1;;
      },
      browserIsChrome() {
        return navigator.userAgent.indexOf("Chrome") !== -1 && navigator.userAgent.indexOf("Edge") === -1;
      },
      browserIsEdge() {
        return navigator.userAgent.indexOf("Edge") !== -1;
      },
    },
    watch: {
      training(to, from) {
        this.drawInputLines(to);
      }
    },
    mounted() {
      this.construct();
      this.drawInputLines(false);
      this.drawOutputLines();
    }
  }
</script>

<style lang="scss" scoped>
    #video-wrapper {
        height: 213px;
        width: 213px;
        overflow: hidden;
        display: block;
        background: #16414c;
        margin: auto;
        border-radius: 15px;
    }

    .loading {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #ffe600;
        z-index: 9998;
    }

    .learning {
        background: #16414c;
        border-radius: 5px;
    }

    .predictedItem {}

    .example-images-grid {
        position: relative;
        background: #cdf3f3;

        &.hasImages {
            &:hover {
                &:after {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    content: "TYHJÄÄ";
                    font-weight: bold;
                    text-align: center;
                    color: #006a64;
                    padding-top: 40%;
                    background: rgba(216, 251, 251, 0.75);
                    z-index: 1;
                    cursor: pointer;
                }
            }
        }
    }

    .contact-buttons .v-btn, .v-tooltip__content {
        color: #072c35;
    }

    .result-gifs-holder {
        position: relative;
        overflow: hidden;
        background: #16414c;
        height: 213px;
        width: 213px;
        margin: auto;
        border-radius: 15px;
    }

    .line-canvas {
        display: none;
    }

    .line-input-canvas {
        position: absolute;
        top: 0;
        left: -57px;
        bottom: 0;
    }

    .line-output-canvas {
        position: absolute;
        top: 0;
        right: -46px;
        bottom: 0;
    }

    .cam-blocked-tip {
        display: none;
        position: fixed;
        font-family: 'Belgrano', serif !important;
        font-size: 14px;
        color: #ffe600;
        white-space: nowrap;

        &.chrome {
            top: 10px;
            right: 125px;

            span {
                padding-top: 50px;
                margin-right: -30px;
                display: inline-block;
            }

            object,
            img {
                float: right;
            }
        }

        &.firefox {
            top: 10px;
            left: 150px;

            span {
                padding-top: 55px;
                margin-right: -40px;
                display: inline-block;
            }

            object,
            img {
                float: right;
            }
        }
    }
    
    .gif-thumbs {
        max-width: 260px;
        margin: auto;

        .gif-thumb {
            display: inline-block;
            border-style: solid;
            border-width: 2px;
            opacity: 0.3;
            transition: opacity 0.3s ease-in-out;

            &.active,
            &:hover {
                opacity: 1;
            }
        }
    }

    @media screen and (min-width: 600px) {
        #video-wrapper {
            height: 143px;
            width: 143px;
            background: #06323d;
        }

        .result-gifs-holder {
            background: #06323d;
            height: 143px;
            width: 143px;
        }

        .camera {
            background-image: url("/images/camera.svg");
            background-repeat: no-repeat;
            width: 261px;
            height: 220px;
            padding-top: 55px;
            padding-left: 24px;
            margin: auto;
        }

        .television {
            background-image: url("/images/television.svg");
            background-repeat: no-repeat;
            width: 221px;
            height: 220px;
            padding-top: 55px;
            margin: auto;
        }
    }

    @media screen and (min-width: 1280px) {
        .cam-blocked-tip {
            display: block;
        }

        .camera {
            margin: 0;
            height: 230px;
        }

        .camera-help {
            margin-left: -10px;
            margin-bottom: 30px;
            color: #a2c3c3;
        }

        .television {
            margin: 0;
            height: 220px;
        }

        .line-canvas {
            display: block;
        }

        .gif-thumbs {
            max-width: 200px;
            margin: 0 0 0 11px;
        }
    }

    @media screen and (min-width: 1500px) {
        .cam-blocked-tip {
            font-size: 16px;
        }
    }

    @media screen and (min-width: 1904px) {
        .line-input-canvas {
            left: -63px;
            width: 63px;
            height: 560px;
        }

        .line-output-canvas {
            right: -47px;
            width: 47px;
        }
    }

</style>
